// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {getBool} from 'mattermost-redux/selectors/entities/preferences';
import {patchChannel} from 'mattermost-redux/actions/channels';

import Constants from 'utils/constants.jsx';

import EditChannelHeaderModal from './edit_channel_header_modal.jsx';

const mapStateToProps = createSelector(
    (state) => getBool(state, Constants.Preferences.CATEGORY_ADVANCED_SETTINGS, 'send_on_ctrl_enter'),
    ({requests}) => {
        const {channels: {updateChannel}} = requests;
        return {
            serverError: updateChannel.error,
            requestStatus: updateChannel.status
        };
    },
    (ctrlSend, submitInfo) => ({
        ctrlSend,
        ...submitInfo
    }),
);

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            patchChannel: bindActionCreators(patchChannel, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EditChannelHeaderModal);



// WEBPACK FOOTER //
// ./components/edit_channel_header_modal/index.js